<!-- eslint-disable vue/html-closing-bracket-newline -->
<!-- eslint-disable vue/max-attributes-per-line -->
<!-- eslint-disable vue/first-attribute-linebreak -->
<!-- eslint-disable vue/html-indent -->
<template>
    <div id="document-pages-container" class="document-container">
        <Page v-for="(image, index) in sortedPreviewImages" :key="image.id" :ref="setPageRefs" :number="index"
            :editable="editable" :areas="areasIndex[index]" :allow-draw="allowDraw" :is-drag="isDrag"
            :default-fields="defaultFields" :default-submitters="defaultSubmitters" :draw-field="drawField"
            :draw-field-type="drawFieldType" :selected-submitter="selectedSubmitter" :image="image"
            :data-page-index="index" @drop-field="$emit('drop-field', { ...$event, attachment_uuid: document.uuid })"
            @remove-area="$emit('remove-area', $event)" @scroll-to="scrollToArea"
            @draw="$emit('draw', { ...$event, attachment_uuid: document.uuid })" />
    </div>
</template>
<script>
import Page from './page'

export default {
    name: 'TemplateDocument',
    components: {
        Page
    },
    props: {
        document: {
            type: Object,
            required: true
        },
        areasIndex: {
            type: Object,
            required: false,
            default: () => ({})
        },
        defaultFields: {
            type: Array,
            required: false,
            default: () => []
        },
        drawFieldType: {
            type: String,
            required: false,
            default: ''
        },
        defaultSubmitters: {
            type: Array,
            required: false,
            default: () => []
        },
        allowDraw: {
            type: Boolean,
            required: false,
            default: true
        },
        selectedSubmitter: {
            type: Object,
            required: true
        },
        editable: {
            type: Boolean,
            required: false,
            default: true
        },
        drawField: {
            type: Object,
            required: false,
            default: null
        },
        baseUrl: {
            type: String,
            required: false,
            default: ''
        },
        isDrag: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: ['draw', 'drop-field', 'remove-area'],
    data() {
        return {
            pageRefs: []
        }
    },
    computed: {
        basePreviewUrl() {
            if (this.baseUrl) {
                return new URL(this.baseUrl).origin
            } else {
                return ''
            }
        },
        numberOfPages() {
            return this.document.metadata?.pdf?.number_of_pages || this.document.preview_images.length
        },
        sortedPreviewImages() {
            const lazyloadMetadata = this.document.preview_images[this.document.preview_images.length - 1].metadata

            return [...Array(this.numberOfPages).keys()].map((i) => {
                return this.previewImagesIndex[i] || {
                    metadata: lazyloadMetadata,
                    id: Math.random().toString(),
                    url: this.basePreviewUrl + `/preview/${this.document.signed_uuid || this.document.uuid}/${i}.jpg`
                }
            })
        },
        previewImagesIndex() {
            return this.document.preview_images.reduce((acc, e) => {
                acc[parseInt(e.filename)] = e

                return acc
            }, {})
        }
    },
    beforeUpdate() {
        this.pageRefs = []
    },
    methods: {
        scrollToArea(area) {
            this.$nextTick(() => {
                this.pageRefs[area.page].areaRefs.find((e) => e.area === area).$el.scrollIntoView({ behavior: 'smooth', block: 'center' })
            })
        },
        scrollToPage(pageIndex) {
            console.log('Document: scrollToPage called with index:', pageIndex)
            // Ensure pageIndex is a number
            pageIndex = parseInt(pageIndex || 0)

            // Make sure this runs after Vue has updated the DOM
            setTimeout(() => {
                try {
                    // Most direct approach - use data attribute
                    const pageWithAttribute = this.$el.querySelector(`[data-page-number="${pageIndex}"]`)
                    if (pageWithAttribute) {
                        console.log('Document: Found page with data-page-number attribute')
                        pageWithAttribute.scrollIntoView({ behavior: 'smooth', block: 'start' })
                        return
                    }

                    // Try to find pages directly
                    const pageElements = this.$el.querySelectorAll('.relative.cursor-crosshair.select-none')
                    console.log('Document: Found', pageElements.length, 'page elements')

                    if (pageIndex >= 0 && pageIndex < pageElements.length) {
                        console.log('Document: Scrolling to page:', pageIndex)
                        pageElements[pageIndex].scrollIntoView({ behavior: 'smooth', block: 'start' })
                    } else {
                        console.log('Document: Invalid page index:', pageIndex, 'total pages:', pageElements.length)
                        // Fallback: try using pageRefs
                        if (pageIndex >= 0 && pageIndex < this.pageRefs.length) {
                            console.log('Document: Using pageRefs fallback')
                            this.pageRefs[pageIndex].$el.scrollIntoView({ behavior: 'smooth', block: 'start' })
                        }
                    }
                } catch (error) {
                    console.error('Document: Error scrolling to page:', error)
                }
            }, 150) // Slightly longer timeout to ensure DOM is ready
        },
        setPageRefs(el) {
            if (el) {
                this.pageRefs.push(el)
            }
        }
    }
}
</script>
